<template>
    <el-dialog
        :visible="visible"
        :modal-append-to-body="false"
        :class="['invoice-detail-dialog', 'ah-detail-dialog', 'gray-bg']"
        top="4vh"
        append-to-body
        :before-close="handleBeforeClose"
        ref="DetailDialog"
    >
        <template slot="title">
            發票 <span class="sno"># {{ this.form.ioo }}</span>
        </template>

        <!-- 進度 -->
        <div class="detail-row progress">
            <ah-audit-progress
                type="invoice"
                :b02Text="form.typ == 4 ? '核銷' : '開立'"
                :data="form.audits"
                :statusCode="form.status"
                size="large"
                :stfNam="form.stF_NAM"
                :createDate="form.crT_DAT"
            ></ah-audit-progress>
        </div>

        <!-- 發票主內容 -->
        <InvoiceMainDataView
            :form="form"
            :isAuditFlowSettingEnable="isAuditFlowSettingEnable"
            :isCreator="isCreator"
            @show="onShowProjectDetail"
            @stateItemChange="
                isStatementChanged = true;
                reload();
            "
            @reload="reload('isInvoiceInfoUpdated')"
        />

        <!-- 上傳文件 -->
        <InvoiceFilesView ref="InvoiceFilesView" :form="form" @reload="reload()" />

        <!-- 發票開立 -->
        <InvoiceIssueView ref="InvoiceIssueView" :form="form" @openDiscount="onEditDiscountNew" @openVoid="onEditVoidNew" @reload="reload('isInvoiceIssued')" @void="handleVoidBtnClick" />

        <!-- 核銷 -->
        <InvoiceReimburseView ref="InvoiceReimburseView" :disable-reimbursement-dialog="disableReimbursementDialog" :form="form" @reload="reload()" />

        <!-- 折讓 -->
        <InvoiceDiscountView ref="discountView" :invoice="form" @endEdit="onDiscountEdited" @reload="reload('isDiscountSubmitted')" @addReturn="onAddReturn" />

        <!-- 作廢 -->
        <InvoiceVoidView ref="voidView" :invoice="form" @endEdit="onVoidEdited" @reload="reload('isVoidSubmitted')" @addReturn="onAddReturn" />

        <!-- 入帳 -->
        <InvoiceArrivedView
            ref="InvoiceArrivedView"
            :isActionEnabled="isArrivedActionShow"
            :form="form"
            @add="onAddArrival"
            @edit="onEditArrival"
            @reload="reload('isPaidSubmitted')"
            @complete="onConfirmPaid"
        />

        <!-- 完成 -->
        <InvoiceCompleteView ref="InvoiceCompleteView" :form="form" />

        <AccountingInfoBlock
            :sno="form.sno"
            :qty="form.voU_COUNT"
            :status="form.vocherStatus"
            :queryType="1"
            :voucher-status-updater="form.voucherStatusUpdateName"
            :voucher-status-update-date="form.voucherStatusUpdateDate"
            :accno='form.accno'
            :accnam='form.accnam'
            :clearanceAccno='form.clearanceAccno'
            :clearanceAccnoNam='form.clearanceAccnoNam'
            @refresh="() => reload()"
        />

        <!-- 退件 -->
        <div v-if="form.status === 4" class="detail-card red">
            <div>
                <div style="color: red;  font-weight: bold; font-size: 12pt; margin-bottom: 10px;">退件</div>
                <!-- <div style="white-space: pre-line">「 {{ auditProgress.rsn }} 」</div> -->
            </div>
            <table class="ah-basic-data-table" cellspacing="0" cellpadding="0">
                <tr>
                    <th>退件原因</th>
                    <td style="color: red"><div style="white-space: pre-line">{{ auditProgress.rsn }}</div></td>
                </tr>
                <tr>
                    <th>退件人</th>
                    <td>{{ auditProgress.stF_NAM }} ({{ auditProgress.sdat | dateFormater("YYYY-MM-dd") }})</td>
                </tr>
            </table>
        </div>

        <!-- 撤銷 -->
        <InvoiceCancelView ref="InvoiceCancelView" :form="form" />

        <!-- 退件操作 -->
        <transition enter-active-class="animate__animated animate__fadeIn ">
            <invoice-reject :show="action == 'reject'" @canceled="action = 'view'" @submitted="handleRejectSubmitted" :sno="form.sno" :audit="auditProgress" :rat="form.rat" />
        </transition>
        <!-- 開立操作 -->
        <transition enter-active-class="animate__animated animate__fadeIn ">
            <invoice-check ref="invoiceCheck" :show="action == 'check'" @canceled="action = 'view'" :invoice="form" :auditProgress="auditProgress" @submitted="handleCheckSubmitted" />
        </transition>
        <!-- 作廢操作 -->
        <transition enter-active-class="animate__animated animate__fadeIn ">
            <invoice-void :show="action == 'void'" @canceled="action = 'view'" @submitted="handleVoidSubmitted" :invoice="form" :sno="form.sno" />
        </transition>
        <!-- Footer 功能按鈕 -->
        <div class="detail-row footer right" v-if="action == 'view' && form.sno != 0">
            <div style="display: flex; justify-content: space-between">
                <div style="display: flex;">
                    <el-button type="" plain @click="handleBeforeClose" icon="el-icon-close"> 返回列表 </el-button>
                    <el-popover
                        placement="top"
                        title="撤銷發票申請"
                        width="220"
                        :close-delay="0"
                        trigger="hover"
                        :content="voidBtnPopoverText || '此發票申請已無效，此帳款將在所有統計中移除。'"
                    >
                        <span slot="reference">
                            <el-button v-if="!isQR()" style="margin-left: 10px" :disabled="!!voidBtnPopoverText" @click="handleVoidBtnClick" icon="el-icon-delete">撤銷發票申請</el-button>
                        </span>
                    </el-popover>
                </div>
                <div>
                    <el-button v-if="isShowEditBtn" type="primary" @click="handleEditBtnClick" icon="el-icon-edit">修改發票</el-button>
                    <el-popover placement="top" title="申請人自行退回" width="220" :close-delay="0" trigger="hover" content="申請人發現發票資訊有誤，自行退回修正。">
                        <el-button v-if="isShowSelfReturnBtn" slot="reference" style="margin-left: 10px" type="" @click="handleSelfReturnBtnClick">
                            申請人自行退回
                        </el-button>
                    </el-popover>
                    <el-popover placement="top" title="退回再編輯" width="220" :close-delay="0" trigger="hover" content="發票內容有誤，退回給申請人重新修正。">
                        <el-button v-if="isShowSimpleRejectBtn" slot="reference" style="margin-left: 10px" type="danger" plain @click="handleSimpleReturnBtnClick('退回再編輯')">
                            退回再編輯
                        </el-button>
                    </el-popover>
                    <el-popover placement="top" title="退件" width="200" :close-delay="0" trigger="hover" content="發票內容有誤，退回給申請人重新修正。">
                        <el-button v-if="isShowRejectBtn" slot="reference" style="margin-left: 10px" type="danger" plain @click="handleRejectBtnClick">退件</el-button>
                    </el-popover>
                    <el-popover placement="top" title="審核通過" width="220" :close-delay="0" trigger="hover" content="已確認發票資訊無誤。">
                        <el-button
                            v-if="isShowPassBtn && !isQR()"
                            slot="reference"
                            type="success"
                            style="margin-left: 10px"
                            class="primary-action"
                            icon="el-icon-check"
                            :loading="isApproving"
                            @click="handlePassBtnClick"
                            >審核通過</el-button
                        >
                    </el-popover>
                    <el-popover placement="top" title="開立發票" width="220" :close-delay="0" trigger="hover" content="開始填寫發票開立資訊">
                        <el-button
                            v-if="form.typ != 4 && isShowCheckBtn && !isQR()"
                            slot="reference"
                            type="success"
                            style="margin-left: 10px"
                            class="primary-action"
                            icon="el-icon-check"
                            @click="handleCheckBtnClick"
                            >開立發票</el-button
                        >
                    </el-popover>
                    <el-popover placement="top" title="核銷" width="220" :close-delay="0" trigger="hover" content="開始填寫核銷資訊。">
                        <el-button
                            slot="reference"
                            type="success"
                            style="margin-left: 10px"
                            @click="handleCheckBtnClick"
                            class="primary-action"
                            v-if="form.typ == 4 && isShowCheckBtn && !isQR()"
                            icon="el-icon-check"
                            >核銷</el-button
                        >
                    </el-popover>
                    <template v-if="form.typ != 4 && isShowIssueEInvoiceBtn && !isQR()">
                        <el-popover v-if="hasFloatInItemPrice" placement="top" title="無法開立電子發票" width="220" :close-delay="0" trigger="hover" content="發票項目中有小數點，請退件後重新編輯。">
                            <el-button slot="reference" type="primary" style="margin-left: 10px" class="primary-action" disabled>開立電子發票</el-button>
                        </el-popover>
                        <el-popover v-else placement="top" title="開立電子發票" width="220" :close-delay="0" trigger="hover" content="開始填寫發票開立資訊">
                            <el-button slot="reference" type="primary" style="margin-left: 10px" class="primary-action" @click="onIssueEInvoiceOpen">開立電子發票</el-button>
                        </el-popover>
                    </template>
                    <el-popover placement="top" title="完成" width="220" :close-delay="0" trigger="hover" content="已完成交易，將此發票狀態設置為完成。">
                        <el-button v-if="isShowPaidBtn && !isQR()" slot="reference" type="success" style="margin-left: 10px" class="primary-action" icon="el-icon-check" @click="onConfirmPaid()">
                            完成
                        </el-button>
                    </el-popover>
                </div>
            </div>
        </div>
        <ProjectDetailDialog ref="projectDetailDialog" :visible="projectDetailDialog.visible" @close="handleProjectDetailDialogClose" :sno="projectDetailDialog.sno" />
        <InvoiceArrivedEditDialog :visible="InvoiceArrivedEditDialog.visible" :invoice="form" :edit-form="InvoiceArrivedEditDialog" @close="onEditClose" @reload="reload('isPaidSubmitted')" />
        <InvoiceEInvoiceDialog :visible="InvoiceEInvoiceDialog.visible" :invoice="form" :auditProgress="auditProgress" @close="onIssueEInvoiceClose" @reload="reload('isInvoiceIssued')" />
        <InvoiceDiscountConfirmDialog
            :visible="InvoiceDiscountConfirmDialog.visible"
            primary-text="是，需要退款給客戶"
            normal-text="否，不需退款"
            @close="onDisConfirmCanceled"
            @confirmed="onDisConfirmed"
        >
            <template v-slot:title>發票已收款，做銷貨折讓/作廢</template>
            <template v-slot:sub-title>您要為此發票做退款嗎？</template>
        </InvoiceDiscountConfirmDialog>
        <InvoiceDiscountConfirmDialog
            :visible="InvoiceVoidConfirmDialog.visible"
            primary-text="我知道了"
            @confirmed="onVoidConfirmed"
        >
            <template v-slot:title>{{ form.foo }} 發票已作廢</template>
            <template v-slot:sub-title>
                <div style="text-align: center;">
                    <div>此作廢發票會紀錄在「營業稅申報」。</div>
                    <div>本單的「入帳/退款」紀錄如需刪除，請手動編輯。</div>
                </div>
            </template>
            <div v-if="!form.projects || form.projects.length > 0" class="project-reinvoice-guide">
                <div class="guide-title">專案發票重開作業</div>
                <div class="guide-description">
                    <ol>
                        <li>建立新的專案分期。</li>
                        <li>重新申請該分期發票。</li>
                    </ol>
                </div>
            </div>
        </InvoiceDiscountConfirmDialog>
        <div id="invoice-detail-bottom-scroll-anchor"></div>
    </el-dialog>
</template>
<script>
import _ from 'lodash';
import ahAuditProgress from '@/components/ui/ahAuditProgress.vue';
import DialogBlockWrapper from '@/components/ui/DialogBlock/DialogBlockWrapper.vue';
import InvoiceReject from './InvoiceReject.vue';
import InvoiceCheck from './InvoiceCheck.vue';
import InvoiceVoid from './InvoiceVoid.vue';
import InvoiceFilesView from './InvoiceDetailDialog/InvoiceFilesView.vue';
import InvoiceIssueView from './InvoiceDetailDialog/InvoiceIssueView.vue';
import InvoiceReimburseView from './InvoiceDetailDialog/InvoiceReimburseView.vue';
import InvoiceDiscountView from './InvoiceDetailDialog/InvoiceDiscountView.vue';
import InvoiceVoidView from './InvoiceDetailDialog/InvoiceVoidView.vue';
import InvoiceArrivedView from './InvoiceDetailDialog/InvoiceArrivedView.vue';
import InvoiceCompleteView from './InvoiceDetailDialog/InvoiceCompleteView.vue';
import InvoiceCancelView from './InvoiceDetailDialog/InvoiceCancelView.vue';
import InvoiceArrivedEditDialog from './InvoiceDetailDialog/InvoiceArrivedEditDialog.vue';
import InvoiceEInvoiceDialog from './InvoiceDetailDialog/InvoiceEInvoiceDialog.vue';
import InvoiceDiscountConfirmDialog from './InvoiceDiscountConfirmDialog.vue';
import InvoiceMainDataView from './InvoiceDetailDialog/InvoiceMainDataView.vue';

export default {
    name: 'InvoiceDetailDialog',
    props: ['visible', 'sno', 'disableReimbursementDialog'],
    components: {
        InvoiceReject,
        InvoiceCheck,
        InvoiceVoid,
        ahAuditProgress,
        ProjectDetailDialog: () => import('@/components/dashboard/Project/ProjectDetailDialog.vue'),
        InvoiceArrivedEditDialog,
        InvoiceEInvoiceDialog,
        InvoiceDiscountConfirmDialog,
        InvoiceFilesView,
        InvoiceIssueView,
        InvoiceReimburseView,
        InvoiceDiscountView,
        InvoiceVoidView,
        InvoiceArrivedView,
        InvoiceCompleteView,
        InvoiceCancelView,
        DialogBlockWrapper,
        InvoiceMainDataView,
        AccountingInfoBlock: () => import('@/components/ui/AccountingInfoBlock.vue'),
    },
    watch: {
        sno(newSno) {
            if (newSno) this.fetchDetailData(newSno);
        },
        visible(newVal) {
            if (!newVal) {
                this.emptyData();
            }
        },
    },
    data() {
        return {
            isInvoiceInfoUpdated: false,
            isCheckSubmitted: false,
            isPaidSubmitted: false,
            isDiscountSubmitted: false,
            isInvoiceIssued: false,
            isVoidSubmitted: false,
            isApproving: false,
            isApproved: false,
            isAuditPassed: false,
            isStatementChanged: false,
            action: 'view', // 檢視:view, 退件:reject, 入帳:paid, 退款折讓:discount, 作廢:void
            invoiceIncomeItemList: [],
            showVoidDialog: false,
            showCheckDialog: false,
            showPaidDialog: false,
            showReturnDialog: false,
            showDiscountDialog: false,
            form: {},
            auditProgress: null,
            projectDetailDialog: {
                visible: false,
                sno: null,
            },
            InvoiceArrivedEditDialog: {
                visible: false,
                form: undefined,
                sno: null,
                flg: 0,
                refound: false,
            },
            InvoiceEInvoiceDialog: {
                visible: false,
            },
            InvoiceDiscountConfirmDialog: {
                visible: false,
            },
            InvoiceVoidConfirmDialog: {
                visible: false,
            },
            discountView: {
                editing: false,
            },

            isAuditFlowSettingEnable: false,
        };
    },
    computed: {
        isAuditor() {
            return _.find(this.auditProgress?.auditors, ['sno', this.$store.getters['account/userSno']]);
        },
        isCreator() {
            return this.form.stF_SNO === this.$store.getters['account/userSno'];
        },
        // 退回按鈕
        isShowRejectBtn() {
            if (this.form.status === 4 || this.form.status === 5 || this.form.status === 2 || this.form.status === 3) {
                return false;
            }
            return this.isAuditor;
        },
        // 審核通過按鈕
        isShowPassBtn() {
            if (this.form.status === 0 && this.isAuditor) return true;

            return false;
        },
        // 編輯按鈕
        isShowEditBtn() {
            if (this.isQR()) return false;
            if (this.form.status === 4 && this.isCreator) return true;
            return false;
        },
        // 開立發票按鈕
        isShowCheckBtn() {
            if (this.form.status === 1 && this.isAuditor) return true;
            return false;
        },
        // 開立電子發票按鈕
        isShowIssueEInvoiceBtn() {
            const HAS_E_INVOICE_SERVICE = this.$store.getters['menu/companyInfo'].eInvoice;
            if (!HAS_E_INVOICE_SERVICE) return false;
            if (this.form.typ === 3 && this.form.status === 1 && this.isAuditor) return true;
            return false;
        },
        // 完成按鈕
        isShowPaidBtn() {
            if (this.form.e_InvoiceDate && this.form.e_InviceIsCanceled) return false;
            if (this.form.status !== 2) {
                return false;
            }
            if (!this.isAuditor) {
                return false;
            }
            if (this.form.incomes && this.form.incomes.length <= 0) {
                return false;
            }
            return true;
        },
        // 入帳按鈕
        isArrivedActionShow() {
            return this.isAuth('B03') && !this.isQR();
        },

        // 銷貨退款按鈕
        isShowDiscountBtn() {
            if ((this.form.status === 2 || this.form.status === 3) && this.isAuth('B03') && !this.form.foO_DIS) {
                return true;
            }
            return false;
        },

        voidBtnPopoverText() {
            if (this.form.foO_DIS_DAT) return '此發票有折讓，無法撤銷。';
            if (this.form.foO_DIS_CNL) return '此發票已作廢，無法撤銷。';
            if (this.form.declared) return '此發票已申報，無法撤銷。';
            if (this.form.e_InvoiceDate) return '此電子發票已開立，無法撤銷。';
            return false;
        },

        // 自行退回按鈕
        isShowSelfReturnBtn() {
            if (this.isQR()) return false;
            // 已申報，不可自行退回
            if (this.form.declared) {
                return false;
            }
            // 已折讓｜已作廢，不可自行退回
            if (this.form.foO_DIS !== 0) {
                return false;
            }
            // 已撤銷，不可自行退回
            if (this.form.foO_CNL !== 0) {
                return false;
            }
            // 核銷已轉開發票，不可自行退回
            if (this.form.tranInvoiceList?.length > 0) return false;

            if (this.form.status === 2 && !this.isAuditFlowSettingEnable && !this.form.e_InvoiceDate && this.isCreator) {
                return true;
            }
            if ((this.form.status === 0 || this.form.status === 1) && this.isCreator) {
                return true;
            }
            return false;
        },

        // 【簡易流程】退回再編輯按鈕
        isShowSimpleRejectBtn() {
            if (this.form.declared) {
                return false;
            }

            // 核銷已轉開發票，不可退件
            if (this.form.tranInvoiceList?.length > 0) return false;

            if (this.form.status === 2 && !this.isAuditFlowSettingEnable && !this.form.e_InvoiceDate && this.isAuth('B03') && !this.isQR()) {
                return true;
            }
            return false;
        },
        // 會計傳票資訊
        isAccountingVoucherDetailShow() {
            return this.form.status === 2 || this.form.status === 3;
        },
        // 發票項目含有小數點
        hasFloatInItemPrice() {
            for (let i = 0; i < this.form.invoiceItems.length; i += 1) {
                if (this.form.invoiceItems[i].pri.toString().indexOf('.') !== -1) {
                    return true;
                }
            }
            return false;
        },
    },
    async created() {
        await this.fetchAuditFlow();
        this.fetchInvoiceIncomeItemList();
        this.emptyData();
    },
    destroyed() {
        document.body.classList.remove('detail-opened');
    },
    methods: {
        async fetchAuditFlow() {
            const resp = await this.$api({
                url: '/Tool/GetAuditFlowTemplates',
                method: 'GET',
            });

            this.isAuditFlowSettingEnable = resp.data.invoiceAuditFlowSetting.isEnable;
        },
        // 重置
        emptyData() {
            this.action = 'view';
            this.form = {
                sno: 0,
                typ: 3,
                projects: [],
            };
            this.isCheckSubmitted = false;
            this.isPaidSubmitted = false;
            this.isDiscountSubmitted = false;
            this.isInvoiceIssued = false;
            this.isInvoiceInfoUpdated = false;
            this.isVoidSubmitted = false;
            this.isApproving = false;
            this.isApproved = false;
            this.isAuditPassed = false;
            this.isStatementChanged = false;
        },

        // 重新載入
        reload(state) {
            if (state) this[state] = true;
            this.action = 'view';
            return this.fetchDetailData(this.form.sno);
        },

        // 載入發票單資料
        fetchDetailData(sno) {
            const loadingTarget = this.$refs.DetailDialog.$el.querySelector('.el-dialog');
            const loading = this.$loading({
                lock: true,
                text: '載入中',
                spinner: 'el-icon-loading',
                target: loadingTarget,
            });

            return this.$api({
                url: `/InvoiceManagemnetPage/GetInvoiceInfo?Sno=${sno}`,
                method: 'GET',
            })
                .then((resp) => {
                    console.log('Invoice Detail: ', resp);
                    this.form = resp.data.item.item;
                    this.auditProgress = resp.data.item.auditProgress;

                    // 增加專案名稱對應欄位
                    for (let j = 0; j < this.form.projects.length; j += 1) {
                        this.form.projects[j].nam = this.form.projects[j].projectName;
                    }
                })
                .finally(() => {
                    loading.close();
                });
        },

        // 取得收支項目列表
        fetchInvoiceIncomeItemList() {
            this.$api({
                url: '/Tool/GetIncomeStatementSettings',
                method: 'GET',
            }).then((resp) => {
                this.invoiceIncomeItemList = resp.data.invoiceSettings;
            });
        },

        // 編輯按下
        handleEditBtnClick() {
            this.$router.push({
                name: 'invoice-edit',
                params: { sno: this.form.sno },
            });
        },
        // 按下退件
        handleRejectBtnClick() {
            this.action = 'reject';
            this.scrollToId('invoice-detail-reject-anchor');
        },
        // 申請人自行退回
        handleSelfReturnBtnClick() {
            this.isApproving = true;

            this.$confirm('確定要自行退回該發票申請？', {
                confirmButtonText: '確定',
                cancelButtonText: '取消',
            })
                .then(() => {
                    const form = {
                        invoiceSno: this.form.sno,
                        foo: '',
                        isTakeBack: true,
                        bankNote: this.form.bankNote,
                        rat: this.form.rat,
                        auditProgress: {
                            sno: this.auditProgress.sno,
                            sot: this.auditProgress.sot,
                            fin: 3,
                            rsn: '申請人自行取回',
                            menU_UNT: this.auditProgress.menU_UNT,
                        },
                    };
                    this.$api({
                        url: '/InvoiceManagemnetPage/AuditInvoice',
                        method: 'post',
                        data: form,
                    })
                        .then(() => {
                            this.fetchDetailData(this.form.sno);
                        })
                        .catch((e) => {
                            console.log(e);
                            this.reload();
                            this.isAuditPassed = true;
                        })
                        .finally(() => {
                            this.isApproving = false;
                            this.isApproved = true;
                        });
                })
                .catch(() => {});
        },
        // 退回再編輯
        async handleSimpleReturnBtnClick(rsn) {
            this.isApproving = true;

            try {
                await this.$confirm('確定要退回該發票申請？', {
                    confirmButtonText: '確定',
                    cancelButtonText: '取消',
                });

                const form = {
                    invoiceSno: this.form.sno,
                    foo: '',
                    rat: this.form.rat,
                    bankNote: this.form.bankNote,
                    auditProgress: {
                        sno: this.auditProgress.sno,
                        sot: this.auditProgress.sot,
                        fin: 3,
                        rsn,
                        menU_UNT: this.auditProgress.menU_UNT,
                    },
                };
                try {
                    await this.$api({
                        url: '/InvoiceManagemnetPage/AuditInvoice',
                        method: 'post',
                        data: form,
                    });

                    this.fetchDetailData(this.form.sno);
                } catch (e) {
                    console.log(e);
                    this.reload();
                    this.isAuditPassed = true;
                } finally {
                    this.isApproving = false;
                    this.isApproved = true;
                }
            } catch (e) {
                console.log(e);
            }
        },
        // 退件送出後
        handleRejectSubmitted() {
            this.$emit('close', true);
            this.action = 'view';
        },

        // 按下開立
        handleCheckBtnClick() {
            this.action = 'check';
            this.scrollToId('invoice-detail-check-anchor');

            this.$nextTick(() => {
                this.$refs.invoiceCheck.initAuSuggestAccountingItemsSelector();
            });
        },

        // 按下開立電子發票
        onIssueEInvoiceOpen() {
            this.InvoiceEInvoiceDialog.visible = true;
            // this.scrollToId('invoice-detail-check-anchor');
        },
        onIssueEInvoiceClose() {
            this.InvoiceEInvoiceDialog.visible = false;
            // this.scrollToId('invoice-detail-check-anchor');
        },

        // 開立送出後
        handleCheckSubmitted() {
            this.isCheckSubmitted = true;
            this.reload().then(() => {
                this.scrollToId('invoice-detail-bottom-scroll-anchor');
            });
        },

        // 按下作廢
        handleVoidBtnClick() {
            this.action = 'void';
            this.scrollToId('invoice-detail-void-anchor');
        },
        // 作廢送出後
        handleVoidSubmitted() {
            this.isVoidSubmitted = true;
            this.reload().then(() => {
                this.scrollToId('invoice-detail-bottom-scroll-anchor');
            });
        },

        // 按下完成按鈕
        async onConfirmPaid(addPS) {
            // 確認金額相符
            const isAmtValidate = this.form.amt
                - _.chain(this.form.incomes)
                    .sumBy((o) => o.amount * o.flg)
                    .value();

            try {
                const confirmText = isAmtValidate !== 0 ? '已入帳金額與發票金額不符' : '請再次確認資訊內容';
                await this.$confirm(`${confirmText}，確定完成？`, {
                    confirmButtonText: '確定完成',
                    cancelButtonText: '取消',
                });
                const data = {
                    invoiceSno: this.form.sno,
                    foO_DAT: this.form.foO_DAT,
                    rat: this.form.rat,
                    code: this.form.code || undefined,
                    auditProgress: {
                        sno: this.auditProgress ? this.auditProgress.sno : null,
                        sot: this.auditProgress ? this.auditProgress.sot : null,
                        fin: 1,
                        rsn: null,
                        menU_UNT: this.auditProgress ? this.auditProgress.menU_UNT : '',
                    },
                };
                await this.$api({
                    url: '/InvoiceManagemnetPage/AuditInvoice',
                    method: 'post',
                    data,
                });

                if (addPS) await addPS();

                this.handlePaidSubmitted();
                this.$message.success('發票已完成！');
            } catch (e) {
                console.log(e);
                this.reload();
                this.isAuditPassed = true;
                this.$refs.InvoiceArrivedView?.onCloseNonIncomeInvoice();
            } finally {
                this.isSubmitting = false;
            }
        },

        // 入帳送出後
        handlePaidSubmitted() {
            this.isPaidSubmitted = true;
            this.reload().then(() => {
                this.scrollToId('invoice-detail-bottom-scroll-anchor');
            });
        },

        // 按下折讓退款
        onEditDiscount() {
            this.action = 'discount';
            // this.scrollToId('invoice-detail-discount-anchor');
        },
        onEditDiscountNew() {
            this.$refs.discountView.startDiscount();
            setTimeout(() => {
                this.scrollToId('invoice-detail-discount-view');
            }, 200);
        },
        onEditVoidNew() {
            this.$refs.voidView.startVoid();
            setTimeout(() => {
                this.scrollToId('invoice-detail-void-view');
            }, 200);
        },
        onDiscountEdited(refresh) {
            if (refresh) {
                this.isDiscountSubmitted = true;
                this.reload().then(() => {
                    // 判斷有折讓，有入帳，無退款時，出現是否接著退款視窗。
                    console.log('this.form.foO_DIS_AMT', this.form.foO_DIS_AMT);
                    console.log('this.form.foO_DIS_CNL', this.form.foO_DIS_CNL);
                    console.log('this.form.incomes.length', this.form.incomes.length);
                    console.log('has', !this.form.incomes.find((x) => x.flag === -1));
                    if (this.form.foO_DIS_CNL) {
                        this.InvoiceVoidConfirmDialog.visible = true;
                    } else if (this.form.foO_DIS_AMT > 0 && this.form.incomes.length >= 1 && !this.form.foO_DIS_CNL && !this.form.incomes.find((x) => x.flag === -1)) {
                        this.openConfirmDialog();
                    }
                });
            }
        },

        onVoidEdited(refresh) {
            if (refresh) {
                this.isDiscountSubmitted = true;
                this.reload().then(() => {
                    // 判斷有折讓，有入帳，無退款時，出現是否接著退款視窗。
                    console.log('this.form.foO_DIS_AMT', this.form.foO_DIS_AMT);
                    console.log('this.form.foO_DIS_CNL', this.form.foO_DIS_CNL);
                    console.log('this.form.incomes.length', this.form.incomes.length);
                    console.log('has', !this.form.incomes.find((x) => x.flag === -1));
                    if (this.form.foO_DIS_CNL) {
                        this.InvoiceVoidConfirmDialog.visible = true;
                    } else if (this.form.foO_DIS_AMT > 0 && this.form.incomes.length >= 1 && !this.form.foO_DIS_CNL && !this.form.incomes.find((x) => x.flag === -1)) {
                        this.openConfirmDialog();
                    }
                });
            }
        },

        // 折讓退款送出後
        handleDiscountSubmitted(disAmt) {
            this.isDiscountSubmitted = true;
            if (disAmt) this.openConfirmDialog();
            this.reload().then(() => {
                this.scrollToId('invoice-detail-bottom-scroll-anchor');
            });
        },

        // 主管/指定審核人 同意
        handlePassBtnClick() {
            this.isApproving = true;

            this.$confirm('確認同意該發票申請？', {
                confirmButtonText: '確定',
                cancelButtonText: '取消',
            })
                .then(() => {
                    const form = {
                        invoiceSno: this.form.sno,
                        foo: '',
                        rat: this.form.rat,
                        auditProgress: {
                            sno: this.auditProgress.sno,
                            sot: this.auditProgress.sot,
                            fin: 1,
                            rsn: '',
                            menU_UNT: this.auditProgress.menU_UNT,
                        },
                    };
                    this.$api({
                        url: '/InvoiceManagemnetPage/AuditInvoice',
                        method: 'post',
                        data: form,
                    })
                        .then(() => {
                            this.fetchDetailData(this.form.sno);
                        })
                        .catch((e) => {
                            console.log(e);
                            this.reload();
                            this.isAuditPassed = true;
                        })
                        .finally(() => {
                            this.isApproving = false;
                            this.isApproved = true;
                        });
                })
                .catch(() => {});
        },

        startFooChange() {
            this.fooChangeForm.foo = this.form.foo;
            this.fooChangeForm.foO_DAT = this.form.foO_DAT;
            this.isShowFooEditer = true;
        },

        submitFooChange() {
            // 發票號碼輸入不完整
            if (!this.invoiceSerialInputValidate) {
                this.$message({
                    showClose: true,
                    message: '請輸入完整發票號碼',
                    type: 'error',
                });
                return;
            }
            this.$api({
                url: '/InvoiceManagemnetPage/UpdateInvoiceSimpleInfo',
                method: 'post',
                data: {
                    invoiceSno: this.form.sno,
                    foo: this.fooChangeForm.foo,
                    foO_DAT: this.fooChangeForm.foO_DAT,
                },
            })
                .then(() => {
                    this.$message({
                        showClose: true,
                        message: '發票資訊已儲存。',
                        type: 'success',
                    });
                    this.reload();
                })
                .finally(() => {
                    this.isShowFooEditer = false;
                });
        },

        cancelFooChange() {
            this.isShowFooEditer = false;
            this.fooChangeForm.foo = this.form.foo;
            this.fooChangeForm.foO_DAT = this.form.foO_DAT;
        },

        onShowProjectDetail(projectSno) {
            this.projectDetailDialog.visible = true;
            this.projectDetailDialog.sno = projectSno;
        },
        handleProjectDetailDialogClose() {
            this.projectDetailDialog.visible = false;
            this.projectDetailDialog.sno = null;
        },

        // 關閉視窗
        handleBeforeClose(done) {
            // 正在編輯狀態，彈出是否關閉（防止編輯中誤觸而資料消失）
            if (this.action !== 'view' || this.$refs.discountView.isEditing) {
                this.$confirm('您正在編輯，確認要關閉發票？', {
                    confirmButtonText: '確定',
                    cancelButtonText: '取消',
                })
                    .then(() => {
                        done();
                        this.$emit('close');
                        this.emptyData(); // 為了下次開啟不顯示之前的資料
                    })
                    .catch(() => {});
            } else {
                // 瀏覽狀態，隨時可以關閉
                // 剛才行政審核過, 回表格要重新載入
                if (
                    this.isCheckSubmitted
                    || this.isPaidSubmitted
                    || this.isDiscountSubmitted
                    || this.isInvoiceIssued
                    || this.isInvoiceInfoUpdated
                    || this.isApproved
                    || this.isAuditPassed
                    || this.isVoidSubmitted
                    || this.isStatementChanged
                ) {
                    this.$emit('close', true);
                } else {
                    this.$emit('close', false);
                }

                this.emptyData(); // 為了下次開啟不顯示之前的資料
            }
        },

        // 編輯多次入帳
        onAddArrival(flg) {
            this.InvoiceArrivedEditDialog.visible = true;
            this.InvoiceArrivedEditDialog.flg = flg;
        },
        onAddRefound(refound) {
            this.InvoiceArrivedEditDialog.visible = true;
            this.InvoiceArrivedEditDialog.flg = -1;
            this.InvoiceArrivedEditDialog.refound = refound;
        },
        onEditArrival(form) {
            this.InvoiceArrivedEditDialog.visible = true;
            this.InvoiceArrivedEditDialog.form = { ...form };
            this.InvoiceArrivedEditDialog.flg = form.flg;
        },
        onEditClose() {
            this.InvoiceArrivedEditDialog.visible = false;
            this.InvoiceArrivedEditDialog.form = undefined;
            this.InvoiceArrivedEditDialog.refound = undefined;
            this.InvoiceArrivedEditDialog.flg = 0;
        },

        // 折讓自動詢問退款相關event
        openConfirmDialog() {
            this.InvoiceDiscountConfirmDialog.visible = true;
        },
        onDisConfirmCanceled() {
            this.InvoiceDiscountConfirmDialog.visible = false;
        },
        onDisConfirmed() {
            this.onAddRefound(this.form.foO_DIS_AMT);
            this.onDisConfirmCanceled();
        },
        onVoidConfirmed() {
            this.InvoiceVoidConfirmDialog.visible = false;
        },
        onAddReturn(amt) {
            this.onAddRefound(amt);
        },
    },
};
</script>

<style lang="scss" scoped>
.invoice-detail-dialog .discount-color {
    color: #f00;
}
</style>

<style lang="scss">
@import "@/assets/scss/vars.scss";

.invoice-detail-dialog {

    @media print {
        position: relative;
    }

    .ah-status {
        margin-bottom: 10px;
    }

    .amt-summary {
        max-width: 400px;
        text-align: right;
        margin: 30px 0 0 auto;

        @media (max-width: 720px) {
            display: block;

            .spec-item .label {
                text-align: left;
            }
        }
    }
}

.project-reinvoice-guide {
    display: block;
    margin-top: 35px;
    background-color: #fffbe9;
    padding: 20px;
    border-radius: 10px;

    .guide-title {
        font-size: 12pt;
        font-weight: bold;
        color: #c89238;
        text-align: center;
        margin-bottom: 15px;
    }

    .guide-description {
        text-align: center;

        ol {
            display: inline-block;
            text-align: left;
            margin: 0 0 0 -20px;
        }
    }
}
</style>
